import { createRef, RefObject, useEffect, useState } from "react";
import "../../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmog } from "@fortawesome/free-solid-svg-icons";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Feature } from "ol";
import { fromLonLat } from "ol/proj";
import { Point } from "ol/geom";
import { map } from "../../mainLayer/MainLayer";
import { LocationMarkerPopup } from "../../mainLayer/MainWindow";
import Overlay from "ol/Overlay.js";
import ReactDOM from "react-dom";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import { Coordinate } from "ol/coordinate";
import AirQualityPopup from "./airQualityPopup";
import { useTheme } from "../../theme/ThemeContext";
import AddAirLayer, { MarkerAirQuality } from "./AddAirLayer";
import {
  layerButtonValue,
  openWindowsMapRiver,
  riverMap,
} from "../../../src/riverSensors/RiverSensors";
import { useMenu } from "../../roundMenuContext/roundMenuContext";
import { useAllWeatherContext } from "../../provider/AllWeatherProvider";
import goodSensor from "../../assets/Good.png";
import moderateSensor from "../../assets/moderate.png";
import sensitveunhelathySensor from "../../assets/sensitveunhelathy.png";
import unhelathySensor from "../../assets/unhealthy.png";
import veryunhealthySensor from "../../assets/veryunhealthy.png";
import harzardusSensor from "../../assets/hazardus.png";
import {
  EWSSidebarMap,
  openEwsWindowsMap,
} from "../earlyWarning/ShowEarlyWarning";
import {
  HzSidebarMap,
  openWindowsHzMap,
} from "../hazardIncidentsLayers/IncidentsMenuDropDown";
import { useAirQualityContext } from "../../provider/AirQualityProvider";
import { openWindowsRainfallMap, rainfallMap } from "../rainfall/Rainfall";

export interface AirQualitySensor {
  meta_device_id: string;
  name: string;
  latitude: number;
  longitude: number;
  pm10: number;
  pm25: number;
  pm100: number;
  co2: number;
  temperature: number;
  aqi: number;
  timestamp: string;
}

export interface AirQualityDetails {
  sensorId: string | null;
  coordinates: Coordinate | null;
  name: string | null;
  pm10: number | null;
  pm25: number | null;
  pm100: number | null;
  co2: number | null;
  temperature: number | null;
  aqi: number | null;
  timestamp: string | null;
}
export const clickedAirQualityLayerRef: RefObject<
  VectorLayer<VectorSource<Feature<Point>>>
> = createRef();
export const airQualityMap: Map<string, AirQualityDetails> = new Map();
export const openWindowsAirQualityMap = new Map<string, string>();
export const openMarkers = new Map<string, boolean>();

interface AirQualitySensorsProps {
  senddValueFromAirQuality: (value: string) => void;
  sensorType: (value: string) => void;
  openModular: (value: string) => void;
  renderAirQualitySensor: (value: boolean) => void;
  sidebarOpen: (value: boolean) => void;
  minMenuAir: boolean;
  minMenuAirLeft: (open: boolean) => void;
}

const AirQuality: React.FC<AirQualitySensorsProps> = ({
  senddValueFromAirQuality,
  sensorType,
  openModular,
  renderAirQualitySensor,
  sidebarOpen,
  minMenuAir,
  minMenuAirLeft,
}) => {
  const [airQualitySensors, setAirQualitySensors] = useState<
    AirQualitySensor[]
  >([]);
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [isClickedMini, setIsClickedMini] = useState<boolean>(true);
  const [hoveredAirQuality, setHoveredAirQuality] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();
  const [_, setRender] = useState(false);
  const { setMarker } = useAllWeatherContext();
  const {
    AirQualityOpenSidebarMap,
    removeFromAirQualityOpenSidebarMap,
    clearAirQualityOpenSidebarMap,
    setAirQualityOpenSidebarMap,
    setIsLeftkeyClick,
    setIsLeftAir,
    setIsMinEyeClickAir,
    isMinEyeClickAir,
  } = useAirQualityContext();
  const toggleSensorVisibility = () => {
    setRender((prevRender) => {
      const newRender = !prevRender;
      renderAirQualitySensor(newRender);
      return newRender;
    });
  };

  const handleButtonClick = () => {
    setIsClicked((prevState) => !prevState);
    fetchData();
    LocationMarkerPopup("airquality");
    if (!isClicked) {
      const entries = Array.from(AirQualityOpenSidebarMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsAirQualityMap.set(sensorId!, "close");
        }
      });
      clearAirQualityOpenSidebarMap();
    }
  };

  useEffect(() => {
    if (menu === "Air Quality") {
      handleButtonClick();
    }
  }, [menu]);

  useEffect(() => {
    if(isMinEyeClickAir){
      handleButtonClick();
    }
  }, [minMenuAir]);

  useEffect(() => {
    if (!isClicked) {
      senddValueFromAirQuality("Air Quality");
      minMenuAirLeft(false);
    } else {
      senddValueFromAirQuality("");
      minMenuAirLeft(true);
    }
  }, [isClicked]);

  const fetchData = async () => {
    const AIR_QUALITY_URL =
    process.env.REACT_APP_AIR_QUALITY_URL;
    try {
      const response = await fetch(
       `${AIR_QUALITY_URL}`
      );
      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const data: AirQualitySensor[] = responseData;

        setAirQualitySensors(data);
        createOpenPopupmap(data);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const createOpenPopupmap = (data: AirQualitySensor[]) => {
    data.forEach((air) => {
      openWindowsAirQualityMap.set(air.meta_device_id, "close");
    });
  };

  useEffect(() => {
    if (airQualitySensors.length > 0) {
      createMapWithMarkers();
    }
  }, [airQualitySensors]);

  const createMapWithMarkers = async () => {
    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    const sensorGood = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: goodSensor,
        scale: 0.3,
      }),
    });

    const sensorModerate = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: moderateSensor,
        scale: 0.3,
      }),
    });

    const sensorSensitive = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: sensitveunhelathySensor,
        scale: 0.3,
      }),
    });

    const sensorUnhelathy = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: unhelathySensor,
        scale: 0.3,
      }),
    });

    const sensorVeryUnhelathy = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: veryunhealthySensor,
        scale: 0.3,
      }),
    });

    const sensorHazardus = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: harzardusSensor,
        scale: 0.3,
      }),
    });

    const sensorLevels = airQualitySensors.map((marker) => {
      const point = new Point(fromLonLat([marker.longitude, marker.latitude]));

      const feature = new Feature({
        geometry: point,
        id: marker.meta_device_id,
        name: marker.name,
        pm10: marker.pm10,
        pm25: marker.pm25,
        pm100: marker.pm100,
        co2: marker.co2,
        temperature: marker.temperature,
        aqi: marker.aqi,
        timestamp: marker.timestamp,
      });
      let style;
      if (marker.aqi !== null) {
        if (0 < marker.aqi && marker.aqi <= 50) {
          style = sensorGood;
        } else if (50 < marker.aqi && marker.aqi <= 100) {
          style = sensorModerate;
        } else if (100 < marker.aqi && marker.aqi <= 150) {
          style = sensorSensitive;
        } else if (150 < marker.aqi && marker.aqi <= 200) {
          style = sensorUnhelathy;
        } else if (200 < marker.aqi && marker.aqi <= 300) {
          style = sensorVeryUnhelathy;
        } else if (300 < marker.aqi && marker.aqi <= 500) {
          style = sensorHazardus;
        }
      } else {
        style = sensorGood;
      }
      feature.setStyle(style);
      return feature;
    });

    vectorSource.addFeatures(sensorLevels);

    map.on("click", (evt) => {
      const feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        return feature;
      });

      if (feature) {
        setMarker("clickMarker");
      }
      const value = feature
        ? openWindowsAirQualityMap.get(feature.get("id"))
        : undefined;

      if (feature && feature.get("aqi") && value === "close") {
        const geometry = feature.getGeometry() as Point;
        const coordinates = geometry.getCoordinates();
        const sensorId = feature.get("id");
        const name = feature.get("name");
        const pm10 = feature.get("pm10");
        const pm25 = feature.get("pm25");
        const pm100 = feature.get("pm100");
        const co2 = feature.get("co2");
        const temperature = feature.get("temperature");
        const aqi = feature.get("aqi");
        const timestamp = feature.get("timestamp");
        if (name) {
          openWindowsAirQualityMap.set(sensorId, "open");
          showPopup(
            sensorId,
            coordinates,
            name,
            pm10,
            pm25,
            pm100,
            co2,
            temperature,
            aqi,
            timestamp
          );
          if (layerButtonValue === "hawk eye") {
            const entries = Array.from(AirQualityOpenSidebarMap.values());
            const lastEntryIndex = entries.length - 1;
            entries.forEach((details, index) => {
              const { coordinates, sensorId } = details;
              if (coordinates) {
                removeOverlay(sensorId!);
                if (index === lastEntryIndex) {
                  addOverlayClickItemLast(sensorId!, coordinates);
                } else {
                  addOverlayClickItem(sensorId!, coordinates);
                }
              }
            });
          }
        }
      }
      setTimeout(() => {
        setMarker("notClickMarker");
      }, 500);
    });

    AddAirLayer(vectorLayer, isClicked, "airquality");
  };

  useEffect(() => {
    const entries = Array.from(AirQualityOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [AirQualityOpenSidebarMap.size]);

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const handleClose = (sensorId: string) => {
    openWindowsAirQualityMap.set(sensorId, "close");
    openMarkers.set(sensorId, false);
    if (airQualityMap.has(sensorId)) {
      airQualityMap.delete(sensorId);
    }
    removeFromAirQualityOpenSidebarMap(sensorId);
    if (AirQualityOpenSidebarMap.has(sensorId)) {
      AirQualityOpenSidebarMap.delete(sensorId);
    }
    const entries = Array.from(AirQualityOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  };

  useEffect(() => {}, [airQualityMap.entries()]);

  useEffect(() => {}, [openMarkers]);

  const showPopup = (
    sensorId: string | null,
    coordinates: Coordinate | null,
    name: string | null,
    pm10: number | null,
    pm25: number | null,
    pm100: number | null,
    co2: number | null,
    temperature: number | null,
    aqi: number | null,
    timestamp: string | null
  ) => {
    toggleSensorVisibility();
    sensorType("airQualitySensor");
    if (layerButtonValue === "modular") {
      const entries = Array.from(riverMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsMapRiver.set(sensorId!, "close");
        }
      });
      const entriesEws = Array.from(EWSSidebarMap.values());
      entriesEws.forEach((details, index) => {
        const { coordinates, active_pcode } = details;
        if (coordinates) {
          removeOverlay(active_pcode!);
          openEwsWindowsMap.set(active_pcode!, "close");
        }
      });
      const entriesHz = Array.from(HzSidebarMap.values());
      entriesHz.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsHzMap.set(sensorId!, "close");
        }
      });
      const entriesRain = Array.from(rainfallMap.values());
      entriesRain.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsRainfallMap.set(sensorId!, "close");
        }
      });
    }
    //  riverMap.clear();
    //  EWSSidebarMap.clear();
    //  clearEWSOpenSidebarMap();
    if (
      sensorId !== null &&
      coordinates !== null &&
      name !== null &&
      pm10 !== null &&
      pm25 !== null &&
      pm100 !== null &&
      co2 !== null &&
      temperature !== null &&
      aqi !== null &&
      timestamp !== null
    ) {
      const popupElement = document.createElement("airQuality");
      if (layerButtonValue === "hawk eye") {
        ReactDOM.render(
          <AirQualityPopup
            sensorId={sensorId}
            name={name}
            pm10={pm10}
            pm25={pm25}
            pm100={pm100}
            co2={co2}
            temperature={temperature}
            aqi={aqi}
            timestamp={timestamp}
            onClose={handleClose}
          />,
          popupElement
        );
        const overlay = new Overlay({
          element: popupElement,
          autoPan: {
            animation: {
              duration: 250,
            },
          },
        });

        overlay.setPosition(coordinates);
        map.addOverlay(overlay);
        const newAirQuality: AirQualityDetails = {
          sensorId: sensorId,
          coordinates: coordinates,
          name: name,
          pm10: pm10,
          pm25: pm25,
          pm100: pm100,
          co2: co2,
          temperature: temperature,
          aqi: aqi,
          timestamp: timestamp,
        };
        airQualityMap.set(newAirQuality.sensorId!, newAirQuality);
        setAirQualityOpenSidebarMap(newAirQuality.sensorId!, newAirQuality);
      } else if (layerButtonValue === "modular") {
        const newAirQuality: AirQualityDetails = {
          sensorId: sensorId,
          coordinates: coordinates,
          name: name,
          pm10: pm10,
          pm25: pm25,
          pm100: pm100,
          co2: co2,
          temperature: temperature,
          aqi: aqi,
          timestamp: timestamp,
        };
        openModular("modularOpened");
        airQualityMap.set(newAirQuality.sensorId!, newAirQuality);
        setAirQualityOpenSidebarMap(newAirQuality.sensorId!, newAirQuality);
        sidebarOpen(true);
      }
    }
  };

  useEffect(() => {
    if (isClickedMini) {
      setIsLeftAir(false);
    } else {
      setIsLeftAir(true);
    }
  }, [isClickedMini]);

  return (
    <>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={() => {
          setIsMinEyeClickAir(true)
          handleButtonClick();
          setIsLeftkeyClick(true);
          setIsClickedMini((prevState) => !prevState);
        }}
        onTouchStart={() => {
          handleButtonClick();
          setIsLeftkeyClick(true);
          setIsClickedMini((prevState) => !prevState);
        }}
      >
        <div
          onMouseEnter={() => setHoveredAirQuality(true)}
          onMouseLeave={() => setHoveredAirQuality(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon size="1x" icon={faSmog} className="leftside-icon" />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? hoveredAirQuality
                  ? "leftsidemenulist-btn-tooltip-hover-light"
                  : "leftsidemenulist-btn-tooltip-light"
                : "leftsidemenulist-btn-tooltip-clicked-light"
            }
            onMouseEnter={() => setHoveredAirQuality(true)}
            onMouseLeave={() => setHoveredAirQuality(false)}
          >
            Air Quality
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? hoveredAirQuality
                  ? "leftsidemenulist-btn-tooltip-hover"
                  : "leftsidemenulist-btn-tooltip"
                : "leftsidemenulist-btn-tooltip-clicked"
            }
            onMouseEnter={() => setHoveredAirQuality(true)}
            onMouseLeave={() => setHoveredAirQuality(false)}
          >
            Air Quality
          </div>
        )}
      </div>
    </>
  );
};

export default AirQuality;
